/**
 * VeriWine REST API
 * Defintion of VeriWine REST API
 *
 * OpenAPI spec version: 0.1.1
 * Contact: info@short.ch
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface TransferOwnershipRequestDto { 
    tid?: string;
    password?: string;
    recipientLegalType?: RecipientLegalTypeEnum;
    recipientLegalEntityId?: number;
    recipientCustomerId?: number;
}





export enum RecipientLegalTypeEnum {
    Winery = 'winery',
    Exporter = 'exporter',
    Importer = 'importer',
    TransportCompany = 'transport_company',
    Warehouse = 'warehouse',
    Distributor = 'distributor',
    Wholesale = 'wholesale',
    Retail = 'retail',
    ECommerce = 'e_commerce',
    Expert = 'expert',
    ConsumerCellarer = 'consumer_cellarer'
}






